export const ACTIONS_FILTERS = 'filters/actions/'
export const ALERT_LEVELS_FILTERS = 'filters/alert-levels-settings/'
export const ALERT_TEMPLATES_SETTINGS = 'filters/alert-templates-settings/'
export const ALERTS_FILTERS = 'filters/alerts/'
export const AUDITS_FILTERS = 'filters/audits/'
export const CATEGORIES_SETTINGS_FILTERS = 'filters/categories-settings/'
export const CHECK_POINTS_FILTERS = 'filters/check-points/'
export const CONSOLIDATED_REPORT_FILTERS = 'filters/consolidated-reports/'
export const DEFECTS_FILTERS = 'filters/defects/'
export const DIAGNOSIS_FILTERS = 'filters/diagnosis/'
export const GW_CHECKPOINTS_FILTERS = 'filters/gw-checkpoints/'
export const GW_CHECKPOINTS_OVERVIEW_FILTERS = 'filters/gw-checkpoints-overview/'
export const HSE_RISKS_FILTERS = 'filters/hse/'
export const IMPROVEMENT_IDEAS_FILTERS = 'filters/improvement-ideas/'
export const OK_FIRST_PART_CHECK_POINT_FILTERS = 'filters/ok-first-part-check-points/'
export const OK_FIRST_PART_FILTERS = 'filters/ok-first-part/'
export const PEOPLE_FILTERS = 'filters/people/'
export const PPE_MANAGEMENT_FILTERS = 'filters/ppe-management/'
export const PRODUCTS_FILTERS = 'filters/products/'
export const PS_FILTERS = 'filters/problem-solving/'
export const REFERENCE_STATE_FILTERS = 'filters/reference-states/'
export const ROTATION_TABLE_FILTERS = 'filters/rotation-table'
export const SEVEN_WASTE_FILTERS = 'filters/seven-waste/'
export const SKILL_MATRIX_FILTERS = 'filters/skill-matrix/'
export const STANDARD_VIEWER_FILTERS = 'filters/standard-viewer/'
export const STANDARD_WORK_REVIEW_FILTERS = 'filters/standard-work-review/'
export const TEMPLATE_FILTERS = 'filters/templates/'
export const TPM_COMPLETE_TASKS_FILTERS = 'filters/tpm-complete-tasks/'
export const TPM_GROUP_TASKS_FILTERS = 'filters/tpm-groups-tasks/'
export const TPM_SETTINGS_TASKS_FILTERS = 'filters/tpm-settings/'
export const VS_EVALUATION_RESULTS_FILTERS = 'filters/standards-evaluation-results/'
export const VS_FILTERS = 'filters/standards/'
export const VS_SETTINGS_FILTERS = 'filters/standards-settings/'
export const VT_FILTERS = 'filters/virtual-training/'
export const SFM_ISOLATED_CHECKPOINTS = 'filters/isolated-checkpoints/'
